<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="inputValue"
    app
    color="grey darken-2"
    dark
    floating
    mobile-break-point="991"
    persistent
    width="260"
  >
    <template v-slot:img="attrs">
      <v-img
        v-bind="attrs"
        gradient="to top, rgba(0, 0, 0, .7), rgba(0, 0, 0, .7)"
      />
    </template>

    <v-list-item two-line>
      <v-list-item-title class="title">
        Zion
      </v-list-item-title>
    </v-list-item>

    <v-divider class="mx-3 mb-3" />

    <v-list nav>
      <!-- Bug in Vuetify for first child of v-list not receiving proper border-radius -->
      <div />

      <v-list-item
        v-for="(link, i) in linkzio"
        :key="i"
        :to="link.to"
        active-class="primary white--text"
      >
        <v-list-item-action>
          <v-icon>{{ link.icon }}</v-icon>
        </v-list-item-action>

        <v-list-item-title v-text="link.text" />
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import { mapMutations, mapState } from "vuex";

export default {
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    linkzio: [
      {
        to: "/private/connect",
        icon: "mdi-chat",
        text: "Login (first time only)",
      },
      {
        to: "/private/chat",
        icon: "mdi-chat",
        text: "Conversations",
      },
    ],
    linksnetskey: [
      {
        to: "/taxi-fare-calculator",
        icon: "mdi-taxi",
        text: "的士車費計算",
      },
      {
        to: "/cat-generator",
        icon: "mdi-cat",
        text: "cats",
      },
      {
        to: "/what-is-my-ip-address",
        icon: "mdi-network",
        text: "My IP",
      },
      {
        to: "/colorpicker",
        icon: "mdi-monitor",
        text: "Color Picker",
      },
      {
        to: "/checklist",
        icon: "mdi-monitor",
        text: "Check List",
      },
    ],
    links: [
      {
        to: "/",
        icon: "mdi-view-dashboard",
        text: "Dashboard",
      },
      {
        to: "/user-profile",
        icon: "mdi-account",
        text: "User Profile",
      },
      {
        to: "/table-list",
        icon: "mdi-clipboard-outline",
        text: "Table List",
      },
      {
        to: "/typography",
        icon: "mdi-format-font",
        text: "Typography",
      },
      {
        to: "/icons",
        icon: "mdi-chart-bubble",
        text: "Icons",
      },
      {
        to: "/maps",
        icon: "mdi-map-marker",
        text: "Maps",
      },
      {
        to: "/notifications",
        icon: "mdi-bell",
        text: "Notifications",
      },
    ],
  }),

  computed: {
    ...mapState("app", ["image", "color"]),
    inputValue: {
      get() {
        return this.$store.state.app.drawer;
      },
      set(val) {
        this.setDrawer(val);
      },
    },
  },

  methods: {
    ...mapMutations("app", ["setDrawer", "toggleDrawer"]),
  },
};
</script>
